import { ScopeVersion } from '@app/core/model/scope-version'
import { Deliverable } from '@app/features/scoping/models/deliverable.model'
import { plainToInstance } from 'class-transformer'
import { ScopeSection } from '../../model/scope-section'
import { Dictionary, keyBy } from 'lodash'
import { SectionWithChanges } from '@app/shared/components/scope-elements/models/entities-with-changes/section-with-changes.interface'
import { getSectionChanges } from './entity-changes'
import { filterNetChangesDeliverables } from '../store/selectors/change-request.selectors'

const hasSectionValueChanges = (s: SectionWithChanges): boolean =>
  Object.values(s.changes).some((v) => v?.old !== v?.new)

export function mapChangeRequestSections(
  scope: ScopeVersion,
  previewScope: ScopeVersion,
  deliverablesBySection: Dictionary<Deliverable[]>,
  isNetChanges = false
): SectionWithChanges[] {
  const scopeSections = scope?.sections || []
  const previewSections = previewScope?.sections || []

  const scopeSectionIds = new Set(scopeSections.map((c) => c.id))
  const previewSectionsMap = keyBy(previewSections, 'id')
  const scopeSectionsMap = keyBy(scopeSections, 'id')

  const allSections = [...scopeSections, ...previewSections.filter((p) => !scopeSectionIds.has(p.id))]

  const mappedSections = plainToInstance(
    ScopeSection,
    allSections
      .sort((a, b) => a.order - b.order)
      .map((section: ScopeSection) => {
        const deliverables = (deliverablesBySection[section.id] || []).sort((a, b) => a.order - b.order)
        const previewDeliverables = deliverables.filter((d) => !d.isRemoved)

        return {
          ...section,
          deliverables: isNetChanges ? filterNetChangesDeliverables(deliverables) : deliverables,
          changes: getSectionChanges(
            scopeSectionsMap[section.id],
            previewSectionsMap[section.id],
            !!previewScope,
            previewDeliverables
          ),
        }
      })
  )

  return isNetChanges
    ? mappedSections.filter(
        (s) =>
          s.deliverables?.length || !scopeSectionIds.has(s.id) || !previewSectionsMap[s.id] || hasSectionValueChanges(s)
      )
    : mappedSections
}
